import { Form } from 'antd';

import { NewApplicationForm } from '@form/new-application/new-application.form';

import { useApplicationSetup } from './application-setup-first.hook';
import { Description, FormWrapper, Title, Wrapper } from './application-setup-first.style';

export const ApplicationSetupFirstPage = () => {
  const { isLoading, form, error, onFinish, accounts } = useApplicationSetup();

  return (
    <Wrapper>
      <Title level={2} weight={400}>
        Welcome to Universal Api
      </Title>
      <Description>Create your application and get started</Description>
      <FormWrapper>
        <Form.Provider onFormFinish={onFinish}>
          <NewApplicationForm accounts={accounts} error={error} form={form} isLoading={isLoading} />
        </Form.Provider>
      </FormWrapper>
    </Wrapper>
  );
};
